// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3buAQ","top":"styles_top__3pJEB"};